import React from "react";

import type { BoxPlanView } from "@/api/order_check";
import { plural } from "@/lib/order-check";
import { cn } from "@/lib/utils";

/** Паллета с коробками по плану (короба маркетплейса — Ozon `cargo_id`, этап 3г
 *  реестра грузомест). Повод — 00НФ-002149: Ozon ждал два короба, склад
 *  положил одну сборную коробку, портал промолчал. Бэкенд кладёт коробку
 *  только на свободный короб плана того же состава
 *  (`order_check/box_plan.py`), а завершение ждёт все короба
 *  (`plan.box_problems`); экран показывает, сколько собрано и каких коробок
 *  ещё нет. */
export function boxPlanDone(plan: BoxPlanView): boolean {
  return plan.filled === plan.planned && plan.extra.length === 0 && plan.loose === 0;
}

export function BoxPlanProgress({ plan }: { plan: BoxPlanView }): React.ReactElement {
  const done = boxPlanDone(plan);
  return (
    <div className="space-y-1 border-b px-3 py-2 text-[12px]" data-testid="box-plan">
      <div className={cn("font-semibold", done ? "text-emerald-700" : "text-amber-700")}>
        Коробки по плану: собрано {plan.filled} из {plan.planned}
        {plan.on_pallet !== plan.filled ? ` · на паллете ${plan.on_pallet}` : ""}
      </div>
      {plan.free.length > 0 && (
        <ul className="space-y-0.5 text-slate-700">
          {plan.free.map((g, i) => (
            <li key={i}>
              {g.lines.map((l) => l.text).join(" + ")} — {`ещё ${g.count} ${plural(g.count, ["коробка", "коробки", "коробок"])}`}
            </li>
          ))}
        </ul>
      )}
      {plan.extra.length > 0 && (
        <div className="rounded bg-amber-50 px-2 py-1 text-amber-900">
          Не по плану: {plan.extra.join("; ")} — снимите с паллеты.
        </div>
      )}
      {plan.loose > 0 && (
        <div className="rounded bg-amber-50 px-2 py-1 text-amber-900">
          россыпь на паллете: {plan.loose} {plural(plan.loose, ["строка", "строки", "строк"])} — только коробками по плану
        </div>
      )}
      {!done && (
        <div className="text-slate-500">
          Только коробками, ровно как в плане (товар, партия, количество); россыпь не принимается.
        </div>
      )}
    </div>
  );
}
